import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { SessionService } from '@services/session';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export const tokenInterceptorFn: HttpInterceptorFn = (req, next) => {
    const sessionService = inject(SessionService);

    if (req.context.get(SKIP_AUTH)) {
        return next(req);
    }

    let authReq = req;

    const token = sessionService.userToken();
    if (token) {
        authReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`),
        });
    }

    return next(authReq).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 401 && token) sessionService.endSession();
            return throwError(() => error);
        })
    );
};
